<template>
  <CModal :title="`${fileTypeDisplay} download`"
          color="info"
          :show="value"
          @update:show="$emit('input', $event)">
    <div>
      The requested {{ fileTypeDisplay }} file is now available:
    </div>
    <div>
      <a :href="fileLink">Download {{ fileTypeDisplay }}</a>
    </div>
    <div v-if="alertText" class="alert-text">
      {{ alertText }}
    </div>
  </CModal>
</template>

<script>
export default {
  name: 'export-modal',

  props: {
    fileType: {
      type: String,
      default: 'csv',
    },

    fileLink: {
      type: String,
      default: null,
    },

    alertText: {
      type: String,
      default: null,
    },

    value: {
      type: Boolean,
      default: false
    },

  },

  computed: {
    fileTypeDisplay() {
      return this.fileType.toUpperCase();
    },

  },

}
</script>

<style scoped lang="scss">
  .alert-text {
    margin-top: 25px;
    font-size: 80%;
    font-style: italic;
  }

</style>
